import { usePersistedValue } from '@segments/Storage'
import * as React from 'react'

import {
  FormPersistenceProvider as SharedFormPersistenceProvider,
  usePersistedFormValuesCtx,
  usePersistedNoteCtx,
  useShouldRememberFormCtx,
} from '~shared/segments/FormScreen'

import { usePersistedForm } from '../hooks/usePersistedForm'

type TProps = RequiredChildren

/**
 * Wrapper for provider of the persisted form values
 * and the customers choice state – whether store that data or not.
 */
export const FormPersistenceProvider: React.FC<TProps> = ({ children }) => {
  const [rememberForm, setRememberForm] = usePersistedValue<boolean>({
    key: `rememberOrderForm`,
  })

  // persisted values, loaded once at the first render
  const persistedForm = usePersistedForm({ rememberForm })

  // persisted note loaded
  const [persistedNote] = usePersistedValue<string>({ key: `note` })

  return (
    <SharedFormPersistenceProvider
      persistedNote={persistedNote}
      persistedForm={persistedForm}
      rememberForm={rememberForm}
      setRememberForm={setRememberForm}
    >
      {children}
    </SharedFormPersistenceProvider>
  )
}

export { useShouldRememberFormCtx, usePersistedFormValuesCtx, usePersistedNoteCtx }
